// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e323c716","455":"18b8958c","977":"561c4b68"}[chunkId] + ".chunk.js";
};